'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var graphicsHelper = require('../../helper/graphicsHelper');


var Spinner = React.createClass({
  render: function () {
    return (
      <div className="component component-spinner" style={{width:'100%',height:'100%'}}>
        {this.renderLabel()}
        <canvas width={styleHelper.getWidth(this.props)}
                height={styleHelper.getHeight(this.props)} style={{position:'absolute'}} ref="ctx"/>
      </div>
    )
  },
  renderLabel: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
    var fontSize = styleHelper.getFontSize(this.props);
    var style = {
      width: w - 18,
      position: 'absolute',
      left: 5,
      top: 0,
      height: fontSize,
      lineHeight: fontSize + 'px',
      whiteSpace: 'nowrap'
    };
    var divStyle={
      width:style.width,
      height:fontSize + 5,
      bottom:0,
      position:'absolute',
      overflow:'hidden'
    };
    styleHelper.StyleUtil(this.props, style).text();
    if (state === appTypes.ComStatus2.DISABLE) {
      style.color = '#e0e0e0';
    }
    return (
      <div style={divStyle}>
        <label style={style}>{styleHelper.getText(this.props)}</label>
      </div>
    );
  },

  componentDidUpdate: function () {
    this.doPaint();
  },

  componentDidMount: function () {
    this.doPaint();
  },

  doPaint: function () {
    var ctx = ReactDOM.findDOMNode(this.refs.ctx);
    var g = ctx.getContext('2d');
    var clientRect = ctx.getBoundingClientRect();
    var w = clientRect.width;
    var h = clientRect.height;
    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
    var ratio = graphicsHelper.applyDeviceRatio(g,w,h);
    var iconSize = 12 * ratio;
    var c = state === appTypes.ComStatus2.DISABLE ? '#E0E0E0' : '#444';
    graphicsHelper.clearRect(g);
    //g.clearRect(0, 0, clientRect.width, clientRect.height);

    w *= ratio;
    h *= ratio;
    g.beginPath();
    g.strokeStyle = c;
    g.lineWidth = ratio;
    g.moveTo(0, h - 0.5 * ratio);
    g.lineTo(w, h - 0.5 * ratio);
    g.closePath();
    g.stroke();

    g.beginPath();
    g.fillStyle = c;
    g.moveTo(w, h - iconSize);
    g.lineTo(w, h);
    g.lineTo(w - iconSize, h);
    g.closePath();
    g.fill();

  }
});

module.exports = Spinner;


// WEBPACK FOOTER //
// ./src/views/Components/Spinner.jsx